import { restServices } from "cuba/services";
import { useQuery } from "react-query";
import { NotPersisitBprocActors } from "cuba/entities/base/tsadv_NotPersisitBprocActors";

interface UseNextApproversParams {
  request: any;
  currentTaskCode?: string;
  outcome?: any;
  SEND_FOR_APPROVAL: string;
  APPROVE: string;
}

export const useNextApprovers = ({
  request,
  currentTaskCode,
  outcome,
  SEND_FOR_APPROVAL,
  APPROVE,
}: UseNextApproversParams) => {
  return useQuery<NotPersisitBprocActors[] | null>(
    ["nextApprovers", currentTaskCode, request?.id],
    async () => {
      const res = await restServices.bprocService.getNextApprovers({
        request,
        currentTaskCode,
      });

      if (!res || res.length === 0) return null;

      const normalized: NotPersisitBprocActors[] = [
        {
          hrRole: res[0]?.hrRole,
          users: res.map((item) => item.user),
        },
      ];

      return normalized;
    },
    {
      enabled:
        !!request &&
        !!currentTaskCode &&
        !!outcome &&
        (outcome.id === SEND_FOR_APPROVAL || outcome.id === APPROVE),
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  );
};
